import { FaCheck } from "react-icons/fa";
import React from "react";
import { cn } from "@/lib/cn";

interface CustomRadioInputProps {
  id: string;
  label: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
}

const CustomRadioInput: React.FC<CustomRadioInputProps> = ({
  id,
  label,
  checked,
  onChange,
}) => {
  return (
    <div className="flex items-center gap-4 group cursor-pointer">
      <input
        id={id}
        type="radio"
        className="hidden"
        checked={checked}
        onChange={onChange}
      />
      <label htmlFor={id} className="flex items-center gap-2 cursor-pointer">
        <span
          className={cn(
            "border-2 w-5 h-5 rounded-full flex items-center justify-center transition-all",
            checked
              ? " border-transparent bg-primary"
              : "border-primary/50 dark:border-input/80"
          )}
        >
          {checked && <FaCheck size={16} className="text-white" />}
        </span>
        <p className="text-mainLightGray text-sm">{label}</p>
      </label>
    </div>
  );
};

export default CustomRadioInput;
